interface Props {
  text: string;
  style?: Record<string, string>;
}

const InlineError = ({ text = '', style = {} }: Props) => {
  return (
    <div className="min-w-full text-left text-red-900" style={style} data-testid="error-message">
      {text}
    </div>
  );
};

export default InlineError;
